module.exports = __webpack_public_path__ + "assets/img/Logitech-G-2-Social-Static-Ad.9e624f57.png";